import { LoadState } from "../../constants/enums";
import { ICatalogProductsState } from "./CatalogProducts.types";

export const defaultCatalogProductsState: ICatalogProductsState = {
  list: {
    data: [],
    loading: LoadState.NotLoaded,
    totalRecords: 0,
  },
};
